export default state => ({
  ...state,
  isWarningDismissed: true
});
